import { Bot, Library, Menu, Search, Sparkles } from "lucide-react";

type AssistantTopBarProps = {
  selectedCount: number;
  onHome: () => void;
  onSearch: () => void;
  onChat: () => void;
  onMenu: () => void;
};

export function AssistantTopBar({
  selectedCount,
  onHome,
  onSearch,
  onChat,
  onMenu,
}: AssistantTopBarProps) {
  return (
    <header className="assistant-topbar">
      <button className="assistant-topbar__menu" type="button" onClick={onMenu} aria-label="Open knowledge areas">
        <Menu size={20} aria-hidden="true" />
      </button>
      <button className="assistant-topbar__title" type="button" onClick={onHome} aria-label="Lwazi MCS document search home">
        <img src="/lwazi/waving.png" alt="" aria-hidden="true" />
        <span>
          <strong>Lwazi</strong>
          <small>MCS document search</small>
        </span>
      </button>
      <nav className="assistant-topbar__actions" aria-label="Workspace actions">
        <button type="button" onClick={onSearch}>
          <Search size={18} aria-hidden="true" />
          <span>Search</span>
        </button>
        <button type="button" onClick={onHome}>
          <Library size={18} aria-hidden="true" />
          <span>Browse</span>
        </button>
        <button
          className="assistant-topbar__chat"
          type="button"
          onClick={onChat}
          disabled={selectedCount === 0}
          title={selectedCount === 0 ? "Select at least one source to start a chat" : undefined}
        >
          {selectedCount > 0 ? <Sparkles size={18} aria-hidden="true" /> : <Bot size={18} aria-hidden="true" />}
          <span>Ask Lwazi</span>
          {selectedCount > 0 ? <b>{selectedCount}</b> : null}
        </button>
      </nav>
    </header>
  );
}
